import React from 'react';
import AdminLayout from '../components/layout/AdminLayout';
import { StatisticsDashboard } from '../components/admin/StatisticsDashboard';
import { useStatistics } from '../hooks/admin/useStatistics';

const Statistics: React.FC = () => {
  const {
    // User Statistics
    topUsersByOrders,
    topUsersBySpent,
    userStatsByDepartment,
    userStatsByOffice,
    mostActiveUsers,
    // Product Sales Statistics
    topProductsByQuantity,
    topProductsByRevenue,
    productSalesByCategory,
    productSalesTrends,
    mostPopularProducts,
    productSalesByDepartment,
    userProductConsumptionStats,
    // Loading States
    loading,
    error,
    refreshData,
  } = useStatistics();

  return (
    <AdminLayout title="İstatistikler">
      {loading ? (
        <div className="flex justify-center items-center h-64 text-lg font-semibold text-gray-500">Yükleniyor...</div>
      ) : error ? (
        <div className="flex flex-col items-center h-64 text-red-600 font-semibold">
          <div>İstatistikler yüklenirken hata oluştu:</div>
          <div className="text-sm mt-2">{error}</div>
          <button onClick={refreshData} className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-lg">Tekrar Dene</button>
        </div>
      ) : (
        <StatisticsDashboard
          topUsersByOrders={topUsersByOrders}
          topUsersBySpent={topUsersBySpent}
          userStatsByDepartment={userStatsByDepartment}
          userStatsByOffice={userStatsByOffice}
          mostActiveUsers={mostActiveUsers}
          topProductsByQuantity={topProductsByQuantity}
          topProductsByRevenue={topProductsByRevenue}
          productSalesByCategory={productSalesByCategory}
          productSalesTrends={productSalesTrends}
          mostPopularProducts={mostPopularProducts}
          productSalesByDepartment={productSalesByDepartment}
          userProductConsumptionStats={userProductConsumptionStats}
        />
      )}
    </AdminLayout>
  );
};

export default Statistics; 